<template>
	<div class="Minister-top Ministerborder">
		<el-dialog
			title="发布"
			:visible.sync="outerVisible"
			width="1200px"
			@close="outerDiaogClose"
			top="4vh"
		>
			<template slot="title">
				<el-row type="flex" align="middle">
					<span style="font-size: 18px;">发布</span>
					<div style="color: red;margin-left: 20px;">
						<span>温馨提示：</span>
						<p style="display:inline-block">
							1.由于上传次数有限，建议批量发布
						</p>
						<p style="padding-left:60px">
							2.当使用服装模板时,须注意：
							<span style="display:block;text-indent:1em"
								>a.尺码最大值不得小于尺码</span
							>
							<span style="display:block;text-indent:1em"
								>b.必须使用颜色-尺寸双变体,缺一不可</span
							>
						</p>
					</div>
				</el-row>
			</template>
			<el-form label-width="160px" class="outerForm">
				<el-form-item label="分类">
					<el-input
						class="width380"
						:value="classifyData.name"
						placeholder="请输入内容"
						@focus="innerVisible = true"
						readonly
					></el-input>
				</el-form-item>
				<el-form-item label="最佳模板">
					<el-select class="width380" value="暂无最佳模板">
						<el-option
							label="暂无最佳模板"
							value="暂无最佳模板"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="分类模板">
					<el-select
						class="width380"
						v-model="classifyModel"
						value-key="id"
						placeholder="选择分类模板"
						@change="selectChange"
						filterable
					>
						<el-option
							v-for="item in classifyTemplateList"
							:key="item.id"
							:label="`${Number(item.order) + 1}. ${item.name}`"
							:value="item"
						></el-option>
					</el-select>
					<el-button
						type="primary"
						style="margin-left:20px"
						v-show="classifyAttributeList.length"
						@click="resetClassifyAttribute"
					>
						重置分类属性
					</el-button>
				</el-form-item>
				<el-form-item label="目标人群">
					<el-select
						class="width380"
						v-model="TargetAudience" 
						placeholder="请选择目标人群"
						filterable>
						<el-option
							v-for="item in AudienceList"
							:key="item.value"
							:label="item.label"
							:value="item.label">
						</el-option>
					</el-select>
				</el-form-item>
				<template v-if="classifyModel.value == 'Clothing.Clothing'">
					<template
						v-if="
							classifyAttributeList.length &&
								Object.keys(outerForm.attributes).length
						"
					>
						<template v-for="item in classifyAttributeList">
							<div :key="item.value">
								<el-form-item
									:label="item.name"
									v-if="
										classifyAttributeShowSelect.includes(
											item.name
										)
									"
								>
									<div v-if="item.name !== '尺寸单位'">
										<el-input
											class="width380"
											placeholder="自定义"
											v-model.number="
												outerForm.attributes[
													item.value
												][0]
											"
										></el-input>
									</div>
									<div
										v-show="
											item.lengthUnitOfMeasure &&
												item.lengthUnitOfMeasure.length
										"
									>
										<el-select
											v-model="
												outerForm.attributes[
													item.value
												][1]
											"
											class="width380"
											placeholder="请选择"
										>
											<el-option
												v-for="key in item.lengthUnitOfMeasure"
												:key="key"
												:label="key"
												:value="key"
											></el-option>
										</el-select>
									</div>
								</el-form-item>
								<el-form-item
									:label="item.name"
									v-else-if="item.children.length == 1"
								>
									<div>
										<el-input
											class="width380"
											v-model="item.children[0].value"
											:disabled="item.status == 2"
										></el-input>
									</div>
									<div
										v-show="
											item.children &&
												item.children.length
										"
									>
										<template v-for="key in item.children">
											<el-button
												type="primary"
												plain
												:key="key.value"
												@click="
													attributeSelectChange(
														key,
														item
													)
												"
											>
												{{ key.name }}
											</el-button>
										</template>
									</div>
								</el-form-item>
								<el-form-item :label="item.name" v-else>
									<div>
										<el-input
											class="width380"
											:placeholder="
												item.status == 2
													? ''
													: item.name == '尺码最大值'
													? '尺码最大值不能小于尺码'
													: '自定义'
											"
											v-model="
												outerForm.attributes[
													item.value
												][0]
											"
											:disabled="item.status == 2"
										></el-input>
									</div>
									<div
										v-show="
											item.children &&
												item.children.length
										"
									>
										<template v-for="key in item.children">
											<el-button
												type="primary"
												plain
												:key="key.value"
												@click="
													attributeSelectChange(
														key,
														item
													)
												"
											>
												{{ key.name }}
											</el-button>
										</template>
									</div>
								</el-form-item>
							</div>
						</template>
					</template>
				</template>
				<template v-else>
					<template
						v-if="
							classifyAttributeList.length &&
								Object.keys(outerForm.attributes).length
						"
					>
						<template v-for="item in classifyAttributeList">
							<div :key="item.value">
								<el-form-item
									:label="item.name"
									v-if="
										classifyAttributeShowSelect.includes(
											item.name
										)
									"
								>
									<div v-if="item.name !== '尺寸单位'">
										<el-input
											class="width380"
											placeholder="自定义"
											v-model.number="
												outerForm.attributes[
													item.value
												][0]
											"
										></el-input>
									</div>
									<div
										v-show="
											item.lengthUnitOfMeasure &&
												item.lengthUnitOfMeasure.length
										"
									>
										<el-select
											v-model="
												outerForm.attributes[
													item.value
												][1]
											"
											class="width380"
											placeholder="请选择"
										>
											<el-option
												v-for="key in item.lengthUnitOfMeasure"
												:key="key"
												:label="key"
												:value="key"
											></el-option>
										</el-select>
									</div>
								</el-form-item>
								<el-form-item :label="item.name" v-else>
									<div>
										<el-input
											class="width380"
											placeholder=""
											:style="item.name == '长度' || 
													item.name == '宽度' || 
													item.name == '高度' || 
													item.name == '重量' ? 'float:left;margin-right:5px' : ''"
											v-model="
												outerForm.attributes[
													item.value
												][0]
											"
											:disabled="item.status == 2"
										></el-input>
										<p v-if="item.name == '长度' || item.name == '宽度' || item.name == '高度'">CM</p>
										<p v-else-if="item.name == '重量'">KG</p>
									</div>
									<div
										v-show="
											item.children &&
												item.children.length
										"
									>
										<template v-for="key in item.children">
											<el-button
												type="primary"
												plain
												:key="key.value"
												@click="
													attributeSelectChange(
														key,
														item
													)
												"
											>
												{{ key.name }}
											</el-button>
										</template>
									</div>
								</el-form-item>
							</div>
						</template>
					</template>
				</template>
				<p
					v-if="classifyModel.value === 'CE.ConsumerElectronics'"
					style="color:red;padding:0 50px;"
				>
					选择此模板时，商品若有尺寸变体，则尺寸值只能是数字且在此选择单位！
				</p>
			</el-form>
			<!-- 内层dialog 开始 -->
			<el-dialog
				width="1000px"
				title="选择目录"
				:visible.sync="innerVisible"
				append-to-body
				top="4vh"
			>
				<el-tabs type="border-card">
					<el-tab-pane label="常用分类">
						<div>您有以最近使用分类</div>
						<div class="keyword-list">
							<div v-if="commonClassify.length">
								<template v-for="item in commonClassify">
									<div class="list" :key="item.id">
										<el-link
											type="primary"
											@click="classifyDone(item)"
											>{{ item.name }}</el-link
										>
									</div>
								</template>
							</div>
							<div class="no-data" v-else>暂无数据</div>
						</div>
					</el-tab-pane>
					<el-tab-pane label="所有分类">
						<div class="selectNodeValue">
							{{ innerForm.selectNodeValue }}
						</div>
						<el-button
							class="margin-bottom-20"
							type="primary"
							@click="classifyDone({})"
							:disabled="!innerForm.isLastChildNode"
						>
							确定
						</el-button>
						<el-input
							class="margin-bottom-20"
							v-model="innerForm.productKeyword"
							placeholder="输入产品关键字"
							@input="productKeywordInput"
						></el-input>
						<!-- 级联菜单 -->
						<el-cascader-panel
							class="custom-cascader"
							:props="classifyProps"
							:key="areaName"
							@expand-change="cascaderChange"
							@change="cascaderChange($event, true)"
							v-show="!innerForm.productKeyword"
						></el-cascader-panel>
						<!-- 关键字获取的列表 -->
						<div
							class="keyword-list"
							v-show="innerForm.productKeyword"
						>
							<div v-if="keywordList.length">
								<template v-for="item in keywordList">
									<div class="list" :key="item.id">
										<el-link
											type="primary"
											@click="classifyDone(item)"
											v-html="
												`${item.fullNodeNameChinese} - ${item.fullNodeName}`
											"
										>
											<!-- {{ `${item.fullNodeNameChinese} - ${item.fullNodeName}` }}-->
										</el-link>
									</div>
								</template>
							</div>
							<div class="no-data" v-else>暂无数据</div>
						</div>
					</el-tab-pane>
				</el-tabs>
			</el-dialog>
			<!-- 内层dialog 结束 -->
			<div slot="footer" class="dialog-footer">
				<el-button @click="outerVisible = false">取 消</el-button>
				<el-button
					type="primary"
					@click="submitOuterForm"
					:loading="isLoading === 'release'"
					>发布</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>
<script>
let commonClassifyData = {}
import { ajaxPost, Baseurl } from '../../../api/api/api'
export default {
	props: {
		areaName: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			outerForm: {
				ids: [],
				categoryId: '',
				templateValue: '',
				attributes: {},
			},
			classifyData: {},
			classifyModel: '',
			TargetAudience: '',
			innerForm: {
				selectNodeValue: '',
				selectLastNodeId: '',
				productKeyword: '',
				isLastChildNode: false,
			},
			outerVisible: false,
			innerVisible: false,

			classifyTemplateList: [],
			keywordList: [],
			timer: null,
			classifyAttributeShowSelect: [
				'单位数',
				'鞋跟高度',
				'瓦数',
				'尺寸单位',
			],
			classifyAttributeList: [],
			commonClassify: [],
			checkedItemsData: {},
			validateType: 0,
			isLoading: '',
			isTemplateDone: false,
			AudienceList: [
				{ value: 1, label: 'Women' },
				{ value: 2, label: 'Unisex Children' },
				{ value: 3, label: 'Men' },
				{ value: 4, label: 'Boys' },
				{ value: 5, label: 'Girls' },
				{ value: 6, label: 'Unisex Adult' }
			]
		}
	},
	computed: {
		classifyProps() {
			return {
				lazy: true,
				lazyLoad: async (node, resolve) => {
					const { level, data } = node
					let customValue = 0
					if (data) customValue = data.customValue
					let { areaName } = this
					if (areaName === 'GB') areaName = 'UK'
					let nodeArr = []
					let nodes = []
					if (level === 0) {
						nodeArr = await this.getClassifyParentList(areaName)
					} else {
						nodeArr = await this.getClassifyNextList(customValue)
					}
					
					if (nodeArr.length) {
						nodes = nodeArr.map((item) => ({
							label: `${item.nodeNameChinese}-${item.nodeName}`,
							value: item,
							customValue: item.id,
							leaf: !item.isHaveChild,
						}))
					}
					// 通过调用resolve将子节点数据返回，通知组件数据加载完成
					resolve(nodes)
				},
			}
		},
	},
	watch: {
		areaName: {
			handler(newValue, oldValue) {
				if (newValue && newValue !== oldValue) {
					this.innerForm.productKeyword = ''
					this.getTemplateParentList()
					// 获取当前国家下常用分类
					commonClassifyData =
						JSON.parse(localStorage.getItem('commonClassify')) || {}
					this.commonClassify =
						commonClassifyData[this.areaName] || []
				}
			},
			immediate: true,
		},
	},
	methods: {
		init(ids, row, type = 1) {
			console.log(ids, row, type)
			this.isLoading = ''
			if (Array.isArray(ids)) {
				this.outerForm.ids = ids
				this.outerVisible = true
				this.getLatelyClassify()
			}
			// console.log(row);
			this.checkedItemsData = row || {}
			/**
			 * 待发布上传 type===1，点击发布走验证
			 * 修复变体关系 type===2，不走验证
			 * 修复图片信息 type===3，不走验证
			 *
			 * 2020.06.18 目前没有2和3的情况了，但是type等于1还是要响应给父页面
			 */
			this.validateType = type
		},
		close() {
			this.outerVisible = false
		},
		getLatelyClassify() {
			const API = Baseurl + 'submitProductController/selectByProductIds'
			const paramsData = { ids: this.outerForm.ids }
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					const {
						categoryId,
						appCategory,
						content,
						contentType,
					} = data
					// 处理分类
					this.classifyData = {
						id: categoryId,
						name: appCategory && appCategory.fullNodeNameChinese,
					}
					this.outerForm.categoryId = categoryId
					/**
					 * 处理分类模板
					 */
					const classifyTemplateData = JSON.parse(content)
					// 分类模板value
					const classifyKey = contentType
					let isExit = false
					this.outerForm.templateValue = classifyKey
					this.classifyTemplateList.forEach((item) => {
						if (item.value == classifyKey) {
							isExit = true
						}
					})
					if (isExit) {
						// 根据分类模板value查找选中的值
						this.classifyModel = this.classifyTemplateList.find(
							(item) => item.value === classifyKey
						)
						// 处理分类模板子项的值
						this.getTemplateNextList(this.classifyModel.id).then(
							() => {
								for (const item in classifyTemplateData[
									classifyKey
								]) {
									const value =
										classifyTemplateData[classifyKey][item]
									this.outerForm.attributes[
										item
									] = value.split('&&')
								}
							}
						)
					}

					// console.log(classifyTemplateData);
					// classifyModel
					// this.classifyAttributeList = classifyTemplateData
				} else {
					console.log(res.data)
				}
			})
		},
		// 保存最近使用分类
		saveLatelyClassify() {
			/**
			 * 判断当前选中的这条数据是否有属性值，没有就直接返回
			 * 检测本地缓存的数据中有没有当前选中的这条，没有的话就添加进去重新缓存
			 */
			if (!Object.keys(this.classifyData).length) return
			const result = this.commonClassify.some(
				(item) => item.id === this.classifyData.id
			)
			if (!result) {
				this.commonClassify.unshift(this.classifyData)
				this.commonClassify.splice(10)
				commonClassifyData[this.areaName] = this.commonClassify
				localStorage.setItem(
					'commonClassify',
					JSON.stringify(commonClassifyData)
				)
			}
		},
		outerDiaogClose() {
			this.classifyData = {}
			this.classifyModel = ''
			this.TargetAudience = ''
			this.outerForm.categoryId = ''
			this.outerForm.templateValue = ''
			this.outerForm.attributes = {}
			this.classifyAttributeList = []
		},
		// 获取一级分类
		getClassifyParentList(country) {
			const API = Baseurl + 'CategoryController/selectCategoryList'
			const paramsData = { country }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsData)
					.then((res) => {
						const { code, data } = res.data
						if (code === 200) {
							// console.log(data);
							resolve(data)
						} else {
							reject([])
							this.$message.error(message)
						}
					})
					.catch((e) => {
						reject([])
						this.$message.error('获取分类失败')
					})
			})
		},
		// 获取子分类
		getClassifyNextList(id) {
			const API = Baseurl + 'CategoryController/selectCategoryByPid'
			const paramsData = { id }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsData)
					.then((res) => {
						const { code, data } = res.data
						if (code === 200) {
							// console.log(data);
							resolve(data)
						} else {
							this.$message.error(message)
							reject([])
						}
					})
					.catch((e) => {
						this.$message.error('获取分类失败')
						reject([])
					})
			})
		},
		productKeywordInput() {
			if (this.timer) clearTimeout(this.timer)
			this.timer = setTimeout(() => {
				this.getKeywordNodeList()
			}, 1000)
		},
		// 根据内容查找子分类
		getKeywordNodeList() {
			if (!this.innerForm.productKeyword) {
				this.keywordList = []
				return
			}
			const API = Baseurl + 'CategoryController/selectCategoryByNodeName'
			const paramsData = {
				country: this.areaName,
				nodeName: this.innerForm.productKeyword,
			}
			ajaxPost(API, paramsData)
				.then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.keywordList = data
					} else {
						this.$message.error(message)
					}
				})
				.catch((e) => {
					this.$message.error('查找失败')
				})
		},
		cascaderChange(event, isLast = false) {
			const handlerNodeValue = event.map(
				(item) => `${item.nodeNameChinese}-${item.nodeName}`
			)
			this.innerForm.selectNodeValue = handlerNodeValue.join(' / ')
			this.innerForm.isLastChildNode = false
			if (isLast) {
				this.innerForm.isLastChildNode = true
				const lastIndex = event.length - 1
				this.innerForm.selectLastNodeId = event[lastIndex].id
			}
		},
		classifyDone(item) {
			let classifyName = ''
			let classifyId = ''
			if (Object.keys(item).length) {
				classifyName = item.fullNodeNameChinese || item.name || ''
				classifyId = item.id || ''
			} else {
				classifyName = this.innerForm.selectNodeValue
				classifyId = this.innerForm.selectLastNodeId
			}
			this.classifyData = { name: classifyName, id: classifyId }
			this.outerForm.categoryId = classifyId

			this.innerVisible = false
			this.innerForm.selectNodeValue = ''
			this.innerForm.selectLastNodeId = ''
		},
		// 获取分类模板
		getTemplateParentList() {
			const API = Baseurl + 'templateController/selectTemplateByRegion'
			const paramsData = { region: this.areaName }
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					// console.log(data);
					this.classifyTemplateList = data
				} else {
					this.$message.error(message)
				}
			})
		},
		// 获取模板属性
		getTemplateNextList(id) {
			const API =
				Baseurl + 'templateController/selectAllChildTemplateById'
			const paramsData = { id }
			this.isTemplateDone = true
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsData)
					.then((res) => {
						const { code, data } = res.data
						if (code === 200) {
							// console.log(data);
							data.forEach((item) => {
								// console.log(item)
								let attributeValue = ['']
								if (
									this.classifyAttributeShowSelect.includes(
										item.name
									)
								) {
									attributeValue = ['1', '']
									if (item.name === '瓦数') {
										attributeValue[1] =
											item.lengthUnitOfMeasure[0]
									} else if (item.name === '单位数') {
										attributeValue[1] =
											item.lengthUnitOfMeasure[0]
									} else if (item.name === '鞋跟高度') {
										attributeValue[1] =
											item.lengthUnitOfMeasure[1]
									} else if (item.name === '尺寸单位') {
										attributeValue[1] =
											item.lengthUnitOfMeasure[0]
									}
								}
								this.$set(
									this.outerForm.attributes,
									item.value,
									attributeValue
								)
								if (
									item.children &&
									item.children.length == 1
								) {
									// this.$set(this.outerForm.attributes[parent.value], 0, child.value)
									this.$set(
										this.outerForm.attributes[item.value],
										0,
										item.children[0].value
									)
								}
							})

							this.classifyAttributeList = data

							resolve()
							this.isTemplateDone = false
						} else {
							reject()
							this.$message.error(message)
						}
					})
					.catch((e) => {
						resolve()
					})
			})
		},
		selectChange(event) {
			// console.log(event)
			this.outerForm.attributes = {}
			this.classifyAttributeList = []

			const { id, name, type, value } = event
			if (
				Object.keys(this.checkedItemsData).length &&
				this.outerForm.ids.length === 1
			) {
				// 有变体的不能选择无变体的模板，无变体的随便选择
				if (this.checkedItemsData.variantId) {
					if (name.includes('无变体')) {
						this.$message.error(
							'产品信息中有变体，不可选择无变体的分类模板'
						)
						this.classifyModel = ''
						return
					}
				}
				//  else {
				//     if (!name.includes("无变体")) {
				//         this.$message.error(
				//             "产品信息中无变体，不可选择有变体的分类模板"
				//         );
				//         this.classifyModel = "";
				//         return;
				//     }
				// }
			}
			// this.classifyModel = JSON.parse(JSON.stringify(event));
			this.getTemplateNextList(id)
			this.outerForm.templateValue = value
		},
		attributeSelectChange(child, parent) {
			this.$set(this.outerForm.attributes[parent.value], 0, child.value)
		},
		// 重置分类数据
		resetClassifyAttribute() {
			const attributesAll = this.outerForm.attributes
			for (const item in attributesAll) {
				if (attributesAll[item].length === 1) {
					attributesAll[item] = ['']
				}
			}
		},
		submitOuterForm() {
			console.log(this.outerForm.templateValue)
			const parentKey = this.outerForm.templateValue
			let content = { [parentKey]: {} }
			content[parentKey]['TargetAudience'] = this.TargetAudience;
			if (this.validateType === 1) {
				if (!this.outerForm.categoryId) {
					this.$message.error('请选择分类')
					return
				}
				if (!this.outerForm.templateValue) {
					this.$message.error('请选择分类模板')
					return
				}
				if (!this.TargetAudience) {
					this.$message.error('请选择目标人群')
					return
				}
				if (this.isTemplateDone) {
					this.$alert('分类模板数据还未加载完成，请稍候！')
					return
				}
				const attributesData = JSON.parse(
					JSON.stringify(this.outerForm.attributes)
				)
				if (Object.keys(attributesData).length) {
					for (const item in attributesData) {
						content[parentKey][item] = attributesData[item].join(
							'&&'
						)
						// console.log(content[parentKey])
						const resultStr = content[parentKey][item].split(
							'&&'
						)[0]
						if (!resultStr) {
							this.$message.error('请完善分类属性信息')
							return
						}
						if (!/^[0-9]+$/g.test(resultStr)) {
							if (item === 'Wattage') {
								this.$message.error(
									'瓦数输入不合法，请输入非0的数值！'
								)
								return
							}
							if (item === 'Heel Height') {
								this.$message.error(
									'鞋跟高度输入不合法，请输入非0的数值！'
								)
								return
							}
							if (item === 'Unit count') {
								this.$message.error(
									'单位数输入不合法，请输入非0的数值！'
								)
								return
							}
						}
					}
				}
			} else {
				content = { 'ClothingAccessories.ClothingAccessories': {} }
				this.outerForm.categoryId = '1'
				this.outerForm.templateValue = 'Clothing.Clothing'
			}
			this.outerForm.content = content
			this.isLoading = 'release'
			this.$emit('submitOuterForm', this.outerForm, this.validateType)
		},
	},
}
</script>
<style lang="scss" scoped>
/deep/ {
	.outerForm {
		.width380 {
			width: 380px;
		}
	}
	.margin-bottom-20 {
		margin-bottom: 20px;
	}
	.selectNodeValue {
		min-height: 30px;
		display: flex;
		align-items: center;
		padding: 10px 0;
	}
	// 级联面板
	.el-cascader-panel.custom-cascader {
		overflow: auto;
		.el-cascader-menu__wrap {
			height: 400px;
		}
	}
	.keyword-list {
		width: 100%;
		height: 430px;
		border: 1px solid #e4e7ed;
		border-radius: 4px;
		overflow: auto;
		padding: 10px;
		box-sizing: border-box;
		overflow: auto;
		.list {
			min-height: 30px;
			display: flex;
			align-items: center;
			padding: 5px 0;
			white-space: nowrap;
		}
		.no-data {
			text-align: center;
			line-height: 40px;
			color: #999;
			user-select: none;
		}
	}
}
</style>
